import React, { useState, useEffect, useRef } from "react";
import EventNavbar from "./EventNavbar";
import { Wordmark } from "../Brand";
import RegisterModal from "./RegisterModal";
import { Helmet } from "react-helmet-async";
import { useNavigate, useLocation } from "react-router-dom";

const meStyles = `
 html {
  scroll-behavior: smooth;
}
section[id], footer[id] {
  scroll-margin-top: 80px;
}

  .me-page {
    --orange: #f37c23;
    --royal: #002a9b;
    --green: #00a000;
    --ink: #1a1f2e;
    --muted: #5b6577;
    --line: #e4e8f1;
    --cream: #fdf9f4;
    font-family: 'Inter', sans-serif;
    color: var(--ink);
    -webkit-font-smoothing: antialiased;
    background: #fff;
  }
  .me-page * { box-sizing: border-box; }
  .me-page img { display: block; max-width: 100%; }
  .me-page h2, .me-page h3, .me-page h4 {
  font-family: 'Poppins', sans-serif;
  line-height: 1.1;
  margin: 0;
}
.me-page h1 {
  line-height: 1.1;
  margin: 0;
}
  .me-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px;
  }

  /* ========== HERO CARD ========== */
 .me-hero-wrapper {
  padding-top: 72px;
  background: #f0f2f5;
  padding-bottom: 0;
}
.me-hero-card {
  position: relative;
  margin: 0 auto;
  max-width: 1260px;
  border-radius: 40px;
  background: #ffffff;
  border: 1px solid #e0e4ef;
  overflow: hidden;
  isolation: isolate;
  box-shadow: 0 4px 40px rgba(0,0,0,0.10);
  min-height: calc(100vh - 120px);
}

  /* --- Layer: transparent images (positioned absolutely) --- */
  .me-hero-img-tricolor-top {
    position: absolute;
    top: -5px;
    right: 0;
    width: 52%;
    max-width: 680px;
    pointer-events: none;
    z-index: 1;
  }

  .me-hero-img-skyline {
    position: absolute;
    right: 10px;
    bottom: 20px;
    width: 78%;
    max-width: 880px;
    pointer-events: none;
    z-index: 1;
    object-fit: contain;
    object-position: bottom right;
  }

  /* --- Content layer --- */
  .me-hero-content {
    position: relative;
    z-index: 3;
    padding: 36px 52px 40px 52px;
  }
  .me-hero-presents {
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #1a1f2e;
    line-height: 1.4;
    margin-bottom: 18px;
  }
  .me-hero-presents em {
    font-style: italic;
    font-weight: 400;
    color: #4a5568;
    display: block;
    margin-top: 1px;
    font-size: 13px;
  }
  .me-hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #fce4c8, #fad4b0);
  border: 1.5px solid rgba(243,124,35,0.25);
  border-radius: 50px;
  padding: 4px 10px;
  font-family: 'Inter', sans-serif;
  font-size: 10.5px;
  font-weight: 700;
  color: #002a9b;
  letter-spacing: 0.10em;
  margin-bottom: 20px;
  white-space: nowrap;
}


  .me-hero-title {
  font-family: 'Playfair Display', Georgia, serif !important;
  font-weight: 400;
  line-height: 1.0;
  color: #0d1433;
  margin: 0 0 14px;
  letter-spacing: -2px;
  display: block;
}
.me-hero-title .line1 { 
  font-size: clamp(4.5rem, 9.5vw, 8rem); 
  display: block; 
  margin-bottom: -0.2em;
  position: relative;
}
.me-hero-title .line2 { 
  font-size: clamp(3rem, 6.3vw, 4.85rem);
  display: block;
  letter-spacing: -1px;
}
.me-hero-title .line2 .yr { color: var(--orange); }

  .me-hero-tagline {
    font-family: 'Poppins', sans-serif;
    font-size: clamp(0.6rem, 1.1vw, 0.78rem);
    font-weight: 700;
    letter-spacing: 2.5px;
    color: #0d1433;
    text-transform: uppercase;
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  .me-hero-tagline .dot {
    width: 5px; height: 5px;
    border-radius: 50%;
    background: var(--orange);
    flex-shrink: 0;
  }

  .me-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: clamp(0.85rem, 1.4vw, 1.05rem);
    font-weight: 700;
    color: #0d1433;
    margin-bottom: 3px;
  }
  .me-hero-sub2 {
    font-family: 'Poppins', sans-serif;
    font-size: clamp(0.82rem, 1.3vw, 1rem);
    font-weight: 600;
    color: var(--orange);
    margin-bottom: 0;
    line-height: 1.5;
  }
  .me-hero-sub3 {
    font-family: 'Poppins', sans-serif;
    font-size: clamp(0.82rem, 1.3vw, 1rem);
    font-weight: 600;
    color: #00a000;
    margin-bottom: 20px;
  }

  .me-hero-feature {
    display: flex;
    align-items: center;  
    gap: 12px;
    margin-bottom: 28px;
  }
  .me-hero-feature-icon {
    width: 44px; height: 44px;
    border-radius: 8px;
    border: 1.5px solid var(--orange);
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
  }
  .me-hero-feature-icon svg { width: 20px; height: 20px; }
  .me-hero-feature-text {
    font-family: 'Poppins', sans-serif;
    font-size: clamp(0.78rem, 1.2vw, 0.92rem);
    font-weight: 700;
    color: #0d1433;
    line-height: 1.2;
  }

  .me-hero-register-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: var(--orange);
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: clamp(0.82rem, 1.1vw, 0.95rem);
    padding: 13px 28px;
    border-radius: 50px;
    text-decoration: none;
    transition: background 0.2s;
    cursor: pointer;
    border: none;
  }
  .me-hero-register-btn:hover { background: #c55e10; }
  .me-hero-register-btn svg { width: 14px; height: 14px; }

  /* --- Navy wave bottom bar --- */
  .me-hero-bottom {
    position: relative;
    z-index: 3;
    margin-top: 40px;
  }
  .me-hero-wave-svg {
    display: block;
    width: 100%;
    height: auto;
    margin-bottom: -2px;
    object-fit: cover;
  }
  .me-hero-stats-bar {
    background: #0d1433;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .me-hero-stat-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 22px 36px;
    border-right: 1px solid rgba(255,255,255,0.08);
  }
  .me-hero-stat-item:last-child { border-right: none; }
  .me-hero-stat-icon {
    width: 48px; height: 48px;
    border-radius: 50%;
    background: rgba(255,255,255,0.08);
    border: 2px solid rgba(243,124,35,0.6);
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
  }
  .me-hero-stat-icon svg { width: 22px; height: 22px; color: var(--orange); }
  .me-hero-stat-label {
    font-family: 'Poppins', sans-serif;
    font-size: clamp(0.72rem, 1vw, 0.82rem);
    font-weight: 800;
    color: #ffffff;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    margin-bottom: 2px;
  }
  .me-hero-stat-val {
    font-family: 'Inter', sans-serif;
    font-size: clamp(1rem, 0.9vw, 0.78rem);
    color: rgba(255,255,255,0.5);
  }

  /* ========== VISION SECTION ========== */
  .me-vision-section {
    padding: 64px 0;
    background: linear-gradient(135deg, #fff 0%, #fff5ec 50%, #ffe8cc 100%);
    position: relative;
    overflow: hidden;
  }
  .me-vision-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 48px;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  /* ========== STATS ROW ========== */
  .me-stats-section {
    padding: 50px 0;
    background: var(--cream);
    border-top: 1px solid var(--line);
    border-bottom: 1px solid var(--line);
  }
  .me-stats-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 0; }
  .me-stat-item { text-align: center; padding: 0 16px; border-right: 1px solid var(--line); }
  .me-stat-item:last-child { border-right: none; }
  .me-stat-icon-wrap { width: 48px; height: 48px; margin: 0 auto 10px; display: flex; align-items: center; justify-content: center; }
  .me-stat-icon-wrap svg { width: 36px; height: 36px; }
  .me-stat-num { font-family: 'Poppins', sans-serif; font-weight: 800; font-size: 1.6rem; line-height: 1; color: var(--orange); margin-bottom: 4px; }
  .me-stat-lbl { font-size: 0.72rem; font-weight: 500; color: var(--muted); line-height: 1.4; }

  /* ========== WHO YOU CONNECT WITH ========== */
  .me-connect-section {
    padding: 56px 0;
    background: linear-gradient(135deg, #ffe8cc 0%, #fff5ec 40%, #fff 100%);
  }
  .me-section-divider-title {
    display: flex; align-items: center; justify-content: center;
    gap: 16px; margin-bottom: 36px;
  }
  .me-section-divider-title h2 {
    font-size: 0.88rem; font-weight: 700; letter-spacing: 2.5px;
    color: var(--ink); text-transform: uppercase; white-space: nowrap;
  }
  .me-section-divider-title::before,
  .me-section-divider-title::after { content: ''; height: 1.5px; flex: 1; background: linear-gradient(90deg, transparent, var(--orange)); }
  .me-section-divider-title::after { background: linear-gradient(90deg, var(--orange), transparent); }
  .me-connect-grid { display: grid; grid-template-columns: repeat(6, 1fr); gap: 16px; }
  .me-connect-card {
    background: rgba(255, 255, 255, 0.35);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border: 1.5px solid rgba(255, 255, 255, 0.5);
    border-radius: 14px;
    padding: 20px 12px; text-align: center;
    box-shadow: 0 4px 24px rgba(13, 20, 51, 0.06);
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s, transform 0.2s;
  }
  .me-connect-card:hover {
    background: rgba(255, 255, 255, 0.55);
    border-color: rgba(243,124,35,0.4);
    box-shadow: 0 8px 28px rgba(243,124,35,0.15);
    transform: translateY(-3px);
  }
  .me-connect-icon { width: 54px; height: 54px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 10px; }
  .me-connect-icon svg { width: 26px; height: 26px; }
  .me-connect-card h4 { font-size: 0.78rem; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; color: var(--ink); }

  /* ========== SPEAKERS ========== */
  .me-speakers-section {
    background: #0d1433;
    background-image: url('/Event/speakers-bg.avif');
    background-size: cover;
    background-position: center;
    padding: 60px 0;
    overflow: hidden;
  }
  .me-speakers-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 40px; }
  .me-speakers-header h2 { font-size: 1.1rem; font-weight: 700; letter-spacing: 1.5px; color: #fff; text-transform: uppercase; }
  .me-speakers-header h2 .accent { color: var(--orange); }
  .me-speakers-header a { color: #9daac5; font-size: 0.88rem; font-weight: 600; text-decoration: none; display: flex; align-items: center; gap: 6px; }
  .me-speakers-header a:hover { color: #fff; }
  .me-speaker-glass-card {
    background: rgba(255, 255, 255, 0.07);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 20px;
    padding: 36px 20px 32px;
    text-align: center;
    transition: background 0.3s, border-color 0.3s, transform 0.3s;
  }
  .me-speaker-glass-card:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(243, 124, 35, 0.4);
    transform: translateY(-4px);
  }
    .me-speaker-subgrid > div { height: 100%; }
  .me-speaker-glass-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .me-speaker-glass-photo {
    width: 140px; height: 140px;
    border-radius: 50%; overflow: hidden;
    margin: 0 auto 16px;
    border: 2.5px solid rgba(255, 255, 255, 0.2);
    background: rgba(255,255,255,0.08);
    display: flex; align-items: center; justify-content: center;
  }
  .me-speaker-glass-photo img { width: 100%; height: 100%; object-fit: cover; object-position: top; }
  .me-speaker-glass-photo .placeholder-initials {
    font-family: 'Poppins', sans-serif;
    font-size: 1.6rem; font-weight: 700; color: rgba(255,255,255,0.4);
  }
  .me-speaker-glass-card h4 {
    font-family: 'Poppins', sans-serif; font-size: 1.05rem; font-weight: 700;
    color: #fff; margin: 0 0 6px; line-height: 1.3;
  }
  .me-speaker-glass-card p { font-size: 0.88rem; color: #8a96b0; line-height: 1.45; margin: 0; }
  .me-speaker-subgrid {
    display: grid;
    gap: 20px;
    margin: 0 auto 52px;
  }
  .me-speaker-subgrid:last-child { margin-bottom: 0; }
  .me-speaker-subgrid.cols-1 { grid-template-columns: 1fr; max-width: 340px; }
  .me-speaker-subgrid.cols-2 { grid-template-columns: repeat(2, 1fr); max-width: 500px; }
  .me-speaker-subgrid.cols-3 { grid-template-columns: repeat(3, 1fr); max-width: 900px; }
  .me-speaker-subgrid.cols-4 { grid-template-columns: repeat(4, 1fr); }
  .me-speaker-arrow {
    width: 42px; height: 42px; border-radius: 50%;
    background: rgba(255,255,255,0.08);
    border: 1.5px solid rgba(255,255,255,0.2);
    color: #fff; display: flex; align-items: center; justify-content: center;
    cursor: pointer; flex-shrink: 0;
    transition: background 0.2s, border-color 0.2s;
  }
  .me-speaker-arrow:hover { background: var(--orange); border-color: var(--orange); }
  .me-carousel-dots { display: flex; justify-content: center; gap: 8px; }
  .me-carousel-dot { width: 10px; height: 10px; border-radius: 50%; background: rgba(255,255,255,0.25); cursor: pointer; border: none; padding: 0; transition: background 0.2s, width 0.2s; }
  .me-carousel-dot.active { background: var(--orange); width: 28px; border-radius: 5px; }

  /* ── Coming Soon placeholder for not-yet-confirmed speaker panels ── */
  .me-speaker-coming-soon {
    border: 1.5px dashed rgba(255,255,255,0.18);
    border-radius: 20px;
    padding: 36px 20px;
    text-align: center;
    max-width: 900px;
    margin: 0 auto 52px;
  }
  .me-speaker-coming-soon p {
    font-family: 'Poppins', sans-serif;
    font-size: 0.9rem;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: rgba(255,255,255,0.45);
    margin: 0;
  }

  /* ========== AWARDS CARD ========== */
  .me-awards-wrapper {
    background: #f0f2f5;
    padding: 40px 0 56px;
    scroll-margin-top: 80px;
  }
  .me-awards-card {
    max-width: 1260px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1.7fr 1fr 1fr;
    align-items: center;
    gap: 28px;
    background: linear-gradient(135deg, #ffe8cc 0%, #fff5ec 40%, #fff 100%);
    border-radius: 28px;
    padding: 36px 44px;
    position: relative;
    overflow: hidden;
  }
  .me-awards-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 60% 90% at 100% 0%, rgba(0,160,0,0.10) 0%, transparent 60%),
      radial-gradient(ellipse 50% 80% at 0% 100%, rgba(243,124,35,0.14) 0%, transparent 60%);
    pointer-events: none;
  }
  .me-awards-left {
    display: flex;
    align-items: center;
    gap: 24px;
    position: relative;
    z-index: 1;
  }
  .me-awards-trophy {
    flex-shrink: 0;
    width: 110px;
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(243,124,35,0.55);
    overflow: visible;
  }
  .me-awards-trophy img,
  .me-awards-trophy svg {
    transform: scale(2.6); /* ← bump this up/down to resize the image without resizing the card */
  }
  .me-awards-label {
    font-family: 'Poppins', sans-serif;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 2px;
    color: var(--orange);
    text-transform: uppercase;
    margin-bottom: 6px;
  }
  .me-awards-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 800;
    font-size: clamp(1.3rem, 2.2vw, 1.7rem);
    color: #0d1433;
    margin: 0 0 8px;
    text-transform: uppercase;
  }
  .me-awards-title .yr { color: var(--orange); }
  .me-awards-desc {
    font-size: 0.9rem;
    line-height: 1.5;
    color: var(--muted);
    margin: 0;
    max-width: 380px;
  }
  .me-awards-features {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 0 28px;
    position: relative;
    z-index: 1;
  }
  .me-awards-features::before,
  .me-awards-features::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1.5px;
    background: linear-gradient(180deg, transparent 0%, rgba(243,124,35,0.35) 20%, rgba(243,124,35,0.35) 80%, transparent 100%);
  }
  .me-awards-features::before { left: 0; }
  .me-awards-features::after { right: 0; }
  .me-awards-feature {
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: 'Inter', sans-serif;
    font-size: 0.88rem;
    font-weight: 600;
    color: #0d1433;
  }
  .me-awards-feature svg { width: 20px; height: 20px; color: var(--orange); flex-shrink: 0; }
  .me-awards-cta {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    position: relative;
    z-index: 1;
  }
  .me-awards-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: var(--orange);
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 0.92rem;
    padding: 13px 24px;
    border-radius: 50px;
    border: none;
    cursor: pointer;
    text-decoration: none;
    transition: background 0.2s;
    white-space: nowrap;
  }
  .me-awards-btn:hover { background: #c55e10; }

  @media (max-width: 900px) {
    .me-awards-card {
      grid-template-columns: 1fr;
      text-align: center;
      padding: 32px 24px;
      gap: 24px;
    }
    .me-awards-left { flex-direction: column; text-align: center; }
    .me-awards-desc { max-width: none; }
    .me-awards-features {
      padding: 20px 0;
      align-items: center;
    }
    .me-awards-features::before,
    .me-awards-features::after {
      left: 0; right: 0; top: auto; bottom: auto;
      width: auto; height: 1.5px;
      background: linear-gradient(90deg, transparent 0%, rgba(243,124,35,0.35) 20%, rgba(243,124,35,0.35) 80%, transparent 100%);
    }
    .me-awards-features::before { top: 0; }
    .me-awards-features::after { bottom: 0; }
    .me-awards-cta { align-items: center; }
  }

  /* ========== SPONSORS ========== */
  .me-sponsors-section { padding: 56px 0; background: #fff; }
  .me-sponsors-tier { margin-bottom: 40px; }
  .me-sponsors-tier:last-child { margin-bottom: 0; }
  .me-sponsors-tier-label {
    text-align: center; font-size: 0.72rem; font-weight: 700;
    letter-spacing: 2px; color: var(--muted); text-transform: uppercase;
    margin-bottom: 20px;
  }
  .me-sponsor-card {
    border: 1.5px solid var(--line); border-radius: 14px;
    height: 90px; display: flex; align-items: center; justify-content: center;
    background: #fff; transition: border-color 0.2s, box-shadow 0.2s;
    cursor: pointer; overflow: hidden; padding: 12px;
  }
  .me-sponsor-card:hover { border-color: var(--orange); box-shadow: 0 4px 18px rgba(243,124,35,0.1); }
  .me-sponsor-placeholder {
    display: flex; flex-direction: column; align-items: center;
    justify-content: center; gap: 6px; width: 100%; height: 100%;
  }
  .me-sponsor-placeholder-icon {
    width: 36px; height: 36px; border-radius: 8px;
    background: var(--line); display: flex; align-items: center; justify-content: center;
  }
  .me-sponsor-placeholder-icon svg { width: 18px; height: 18px; color: var(--muted); }
  .me-sponsor-placeholder-text {
    font-family: 'Poppins', sans-serif; font-size: 0.65rem; font-weight: 700;
    color: var(--muted); letter-spacing: 0.5px; text-transform: uppercase;
  }

  /* ── Ecosystem / partner cards — photo on top, company name below ── */
  .me-ecosystem-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }
  .me-partner-card {
    border: 1.5px solid var(--line);
    border-radius: 14px;
    background: #fff;
    padding: 18px 16px;
    text-align: center;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
  }
  .me-partner-card:hover {
    border-color: var(--orange);
    box-shadow: 0 8px 24px rgba(243,124,35,0.12);
    transform: translateY(-3px);
  }
  .me-partner-photo {
    width: 100%;
    height: 88px;
    border-radius: 10px;
    background: var(--line);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    overflow: hidden;
  }
  .me-partner-photo img { width: 100%; height: 100%; object-fit: contain; }
  .me-partner-photo svg { width: 26px; height: 26px; color: var(--muted); }
  .me-partner-name {
    font-family: 'Poppins', sans-serif;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: var(--ink);
    text-transform: uppercase;
  }

  /* ── Media partners row ── */
  .me-media-wrapper {
    padding: 8px 0;
  }
  .me-media-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 28px;
  }
  .me-media-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    padding: 4px;
    transition: transform 0.2s;
  }
  .me-media-card:hover { transform: translateY(-2px); }
  .me-media-logo {
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
  }
  .me-media-card img { max-height: 110px; max-width: 100%; object-fit: contain; }
  .me-media-name {
    font-family: 'Poppins', sans-serif;
    font-size: 0.85rem;
    font-weight: 700;
    color: var(--ink);
    line-height: 1.3;
    margin-bottom: 2px;
  }
  .me-media-role {
    font-size: 0.72rem;
    font-weight: 500;
    color: var(--muted);
    line-height: 1.3;
  }
  @media (max-width: 900px) {
    .me-media-grid { grid-template-columns: repeat(3, 1fr); }
  }
  @media (max-width: 580px) {
    .me-media-grid { grid-template-columns: repeat(2, 1fr); }
  }

  /* ========== FAQ ========== */
  .me-faq-section {
    padding: 64px 0 72px;
    background: linear-gradient(180deg, #fdf9f4 0%, #ffffff 100%);
  }
  .me-faq-list {
    max-width: 820px;
    margin: 0 auto;
  }
  .me-faq-item {
    background: #fff;
    border: 1.5px solid var(--line);
    border-radius: 16px;
    overflow: hidden;
    margin-bottom: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  .me-faq-item.open {
    border-color: rgba(243,124,35,0.4);
    box-shadow: 0 8px 24px rgba(243,124,35,0.10);
  }
  .me-faq-question {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: none;
    border: none;
    padding: 20px 24px;
    cursor: pointer;
    text-align: left;
    font-family: inherit;
  }
  .me-faq-q-text {
    font-family: 'Poppins', sans-serif;
    font-size: 0.98rem;
    font-weight: 700;
    color: var(--ink);
    display: flex;
    gap: 8px;
    align-items: baseline;
  }
  .me-faq-q-text span { color: var(--orange); flex-shrink: 0; }
  .me-faq-chevron {
    flex-shrink: 0;
    transition: transform 0.25s ease;
    color: var(--muted);
  }
  .me-faq-chevron.open { transform: rotate(180deg); color: var(--orange); }
  .me-faq-answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }
  .me-faq-answer.open { max-height: 400px; }
  .me-faq-answer-inner {
    padding: 0 24px 22px 24px;
    font-size: 0.92rem;
    line-height: 1.7;
    color: var(--muted);
  }
  @media (max-width: 600px) {
    .me-faq-question { padding: 16px 18px; }
    .me-faq-q-text { font-size: 0.88rem; }
    .me-faq-answer-inner { padding: 0 18px 18px 18px; font-size: 0.86rem; }
  }

  /* ========== FOOTER CTA ========== */
  .me-footer-cta { background: #fff; padding: 40px 0; position: relative; }
  .me-footer-cta-card {
    border-radius: 24px; overflow: hidden; position: relative;
    background: #0d1433;
    background-image: url('/Event/cta-bg.avif');
    background-size: cover; background-position: center; padding: 60px 60px;
  }
  .me-footer-cta-bg {
    position: absolute; inset: 0;
    background:
      radial-gradient(ellipse 50% 80% at -5% 110%, rgba(0,160,0,0.18) 0%, transparent 60%),
      radial-gradient(ellipse 40% 60% at 105% 105%, rgba(243,124,35,0.15) 0%, transparent 60%);
    pointer-events: none;
  }
  .me-footer-cta-inner {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 40px;
    align-items: center;
    position: relative;
    z-index: 2;
  }
  .me-footer-cta-left h2 {
    font-size: clamp(1.6rem, 3vw, 2.2rem); font-weight: 800;
    color: #fff; line-height: 1.2; margin-bottom: 12px;
  }
  .me-footer-cta-left h2 .accent { color: var(--orange); }
  .me-footer-cta-left p { font-size: 0.9rem; color: #8a96b0; line-height: 1.6; margin: 0; }
  .me-footer-cta-middle { display: flex; flex-direction: column; gap: 18px; }
  .me-footer-cta-detail { display: flex; align-items: center; gap: 12px; color: #c0cce8; font-size: 0.95rem; }
  .me-footer-cta-detail svg { width: 20px; height: 20px; color: var(--orange); flex-shrink: 0; }

  /* ========== SPEAKER REVEAL ANIMATION ========== */
.me-speaker-reveal {
  opacity: 0;
  transform: translateY(100px);
  transition: opacity 1.5s ease, transform 1.5s ease;
}
  .me-speaker-reveal.visible {
    opacity: 1;
    transform: translateY(0);
  }
  .me-speakers-subsection-title {
    font-family: 'Poppins', sans-serif;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 2.5px;
    text-transform: uppercase;
    color: rgba(255,255,255,0.45);
    text-align: center;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }
  .me-speakers-subsection-title::before,
  .me-speakers-subsection-title::after {
    content: '';
    height: 1px;
    width: 60px;
    background: rgba(255,255,255,0.18);
  }

  /* --- Venue floating button --- */
  .me-venue-btn {
    position: fixed;
    bottom: 28px;
    left: 28px;
    z-index: 9999;
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #027a02;
    color: #fff;
    border-radius: 50px;
    padding: 12px 20px 12px 14px;
    box-shadow: 0 4px 16px rgba(243,124,35,0.35);
    text-decoration: none;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  }
  .me-venue-btn:hover {
    background-color: #126b12;
    box-shadow: 0 6px 20px rgba(243,124,35,0.5);
    transform: scale(1.05);
  }
  .me-venue-btn svg { width: 22px; height: 22px; flex-shrink: 0; }
  @media (max-width: 480px) {
    .me-venue-btn { padding: 12px; }
    .me-venue-btn .me-venue-btn-label { display: none; }
  }

  /* =============================================
     RESPONSIVE — ordered from LARGE to SMALL
     so smaller breakpoints always win
     ============================================= */

  /* 1100px and below */
  @media (max-width: 1100px) {
    .me-stats-grid { grid-template-columns: repeat(4, 1fr); }
    .me-connect-grid { grid-template-columns: repeat(3, 1fr); }
    .me-vision-grid { grid-template-columns: 1fr 1fr; }
    .me-footer-cta-inner { gap: 24px; }
    .me-footer-cta-card { padding: 48px 40px; }
    .me-footer-cta-detail { font-size: 0.85rem; }
    .me-hero-title .line1 { font-size: 5.5vw; }
    .me-hero-title .line2 { font-size: 3.09vw; white-space: nowrap; }
    .me-hero-img-skyline { width: 52%; }
    .me-hero-img-tricolor-top { width: 48%; }
    .me-hero-card { min-height: auto; }
  }

  @media (min-width: 881px) and (max-width: 1280px) {
  .me-hero-img-skyline {
    opacity: 0.4 !important;
  }
}

/* 769px–1100px: tablet landscape */
@media (min-width: 769px) and (max-width: 1100px) {
  .me-hero-card { min-height: auto; height: auto; }
  .me-hero-img-skyline { position: absolute; bottom: 20px; right: 10px; width: 90%; }
  .me-hero-bottom { position: relative; z-index: 3; margin-top: 0; }
  .me-hero-content { padding-bottom: 20px; }
  .me-hero-title .line1 { font-size: 5.5vw; }
  .me-hero-title .line2 { font-size: 3.6vw; white-space: nowrap; }
}

/* iPad Air (820px) and Asus Zenbook Fold (853px) — narrow tablet portrait */
@media (min-width: 769px) and (max-width: 880px) {
  .me-hero-register-btn {
    margin-bottom: 30px;
  }
  .me-hero-img-skyline {
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 208% !important;
    max-width: 780px !important;
    opacity: 0.4;
  }
}

  /* 900px and below */
  @media (max-width: 900px) {
    .me-speaker-glass-photo { width: 110px; height: 110px; }
    .me-vision-grid { grid-template-columns: 1fr 1fr; }
    .me-vision-section { padding: 44px 0; }
    .me-keynote-grid { grid-template-columns: repeat(3, 1fr) !important; }
    .me-footer-cta-inner { grid-template-columns: 1fr 1fr; grid-template-rows: auto auto; }
    .me-footer-cta-left { grid-column: 1 / -1; }
    .me-footer-cta-card { padding: 40px 32px; }
    .me-hero-content { padding: 28px 32px 0 32px; }
    .me-hero-img-skyline { width: 55%; }
    .me-hero-stat-item { padding: 18px 20px; }
    .me-hero-card { min-height: auto; }
  }

  /* iPad Mini (768px) and below — mobile starts here */
  @media (max-width: 768px) {
    .me-container { padding: 0 20px; }
    .me-hero-wrapper { padding-top: 56px; }
    .me-hero-card { border-radius: 14px; }
    .me-hero-content { padding: 24px 20px 0 20px; }
    .me-hero-img-tricolor-top { width: 65%; }
    .me-hero-img-skyline {
  position: absolute;
  bottom: 150px;
  right: 10px;
  width: 100% !important;
  max-width: 100% !important;
  opacity: 0.4;
  z-index: 1;
}
    .me-hero-stats-bar { grid-template-columns: 1fr; }
    .me-hero-stat-item { border-right: none; border-bottom: 1px solid rgba(255,255,255,0.08); padding: 16px 24px; }
    .me-hero-stat-item:last-child { border-bottom: none; }
    /* iPad Mini 768px: line1=8.8vw → ~67px, line2=4.95vw → ~38px, ratio=1.778 ✓ */
    .me-hero-title .line1 { font-size: 8.8vw; }
    .me-hero-title .line2 { font-size: 4.95vw; white-space: nowrap; }
    .me-hero-tagline { flex-wrap: nowrap; font-size: 0.52rem; letter-spacing: 1.5px; }
    .me-vision-grid { grid-template-columns: 1fr !important; }
    .me-vision-section { padding: 36px 0; }
    .me-stats-grid { grid-template-columns: repeat(2, 1fr); gap: 0; }
    .me-stat-item { border-right: none; border-bottom: 1px solid var(--line); padding: 16px 8px; }
    .me-stat-item:nth-child(odd) { border-right: 1px solid var(--line); }
    .me-stat-item:last-child { border-bottom: none; }
    .me-stat-item:nth-last-child(2):nth-child(odd) { border-bottom: none; }
    .me-connect-grid { grid-template-columns: repeat(3, 1fr); }
    .me-speaker-subgrid.cols-3,
    .me-speaker-subgrid.cols-4 { grid-template-columns: repeat(2, 1fr) !important; gap: 16px; }
    .me-speaker-subgrid.cols-1,
    .me-speaker-subgrid.cols-2 { grid-template-columns: 1fr !important; max-width: 320px; }
    .me-speaker-glass-photo { width: 90px; height: 90px; }
    .me-footer-cta-card { padding: 36px 20px; }
    .me-footer-cta-inner { grid-template-columns: 1fr !important; grid-template-rows: auto !important; gap: 28px; }
    .me-footer-cta-left { grid-column: auto !important; }
    .me-sponsors-platinum-grid { grid-template-columns: repeat(4, 1fr) !important; }
    .me-sponsors-bottom { grid-template-columns: 1fr !important; }
    .me-silver-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .me-ecosystem-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .me-speaker-glass-card { padding: 24px 14px 22px; }
    .me-speaker-glass-card h4 { font-size: 0.92rem; }
    .me-speaker-glass-card p { font-size: 0.78rem; }
  }
    /* iPad Mini (768px) — 3 cards per row for both speaker sections */
 @media (min-width: 600px) and (max-width: 768px) {
    .me-speaker-subgrid.cols-3,
    .me-speaker-subgrid.cols-4 { grid-template-columns: repeat(3, 1fr) !important; }
  }

  /* Surface Duo (540px) and below */
  @media (max-width: 580px) {
    .me-hero-img-skyline {
  position: absolute;
  bottom: 200px;
  right: 10px;
  width: 100% !important;
  max-width: 100% !important;
  opacity: 0.4;
  z-index: 1;
}
    .me-connect-grid { grid-template-columns: repeat(2, 1fr); }
    .me-keynote-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .me-sponsors-platinum-grid { grid-template-columns: repeat(3, 1fr) !important; }
    .me-silver-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .me-ecosystem-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .me-section-divider-title h2 { font-size: 0.75rem; letter-spacing: 1.5px; }
    .me-sponsor-placeholder-text { font-size: 0.6rem; letter-spacing: 0; }
    /* Surface Duo 540px: line1=9.8vw→~53px, line2=5.51vw→~29.8px, ratio=1.778 ✓ */
    .me-hero-title .line1 { font-size: 9.8vw; }
    .me-hero-title .line2 { font-size: 5.51vw; white-space: nowrap; }
    .me-hero-tagline { flex-wrap: nowrap; font-size: 0.46rem; letter-spacing: 1.2px; }
  }

  /* iPhone XR / Pixel 7 / Samsung (412–430px) */
  @media (max-width: 430px) {
    /* 412px: line1=11.0vw→45.3px, line2=6.18vw→25.5px, ratio=1.778 ✓ */
    .me-hero-title .line1 { font-size: 11.0vw; }
    .me-hero-title .line2 { font-size: 6.18vw; white-space: nowrap; }
    .me-hero-tagline { flex-wrap: nowrap; font-size: 0.42rem; letter-spacing: 1px; }
    .me-sponsors-platinum-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .me-silver-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .me-ecosystem-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .me-hero-img-skyline {
    position: absolute;
    bottom: 220px;
    right: 10px;
    width: 100% !important;
    max-width: 100% !important;
    opacity: 0.4;
    z-index: 1;
  }
  }

  /* iPhone 12 Pro / SE and very small phones (≤390px) */
  @media (max-width: 400px) {
    .me-container { padding: 0 12px; }
    .me-connect-grid { grid-template-columns: repeat(2, 1fr); }
    .me-speaker-subgrid.cols-3,
    .me-speaker-subgrid.cols-4 { grid-template-columns: repeat(2, 1fr) !important; gap: 14px; }
    .me-speaker-glass-photo { width: 80px; height: 80px; }
    .me-sponsors-platinum-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .me-footer-cta-card { padding: 28px 14px; border-radius: 16px; }
    .me-footer-cta-detail { font-size: 0.82rem; }
    /* 390px: line1=11.5vw→44.8px, line2=6.47vw→25.2px, ratio=1.778 ✓ */
    .me-hero-title .line1 { font-size: 11.5vw; }
    .me-hero-title .line2 { font-size: 6.47vw; white-space: nowrap; }
    .me-hero-tagline { flex-wrap: nowrap; font-size: 0.38rem; letter-spacing: 0.8px; }
    
  }

  /* =============================================
     FORCE OVERRIDES — highest specificity
     in mein !important hai taaki koi bhi
     pehle ka rule override na kare
     ============================================= */
 @media screen and (max-width: 768px) {
  .me-page .me-hero-title .line1 { font-size: 8.8vw !important; }
  .me-page .me-hero-title .line2 { font-size: 5.65vw !important; white-space: nowrap !important; }
  .me-page .me-hero-tagline { flex-wrap: nowrap !important; font-size: 0.52rem !important; letter-spacing: 1.5px !important; }
  .me-page .me-hero-badge { font-size: 9px !important; padding: 6px 12px !important; gap: 6px !important; white-space: nowrap !important; }
  .me-page .me-hero-badge img { width: 12px !important; height: 12px !important; }
}
@media screen and (max-width: 580px) {
  .me-page .me-hero-title .line1 { font-size: 9.8vw !important; }
  .me-page .me-hero-title .line2 { font-size: 6.3vw !important; white-space: nowrap !important; }
  .me-page .me-hero-tagline { flex-wrap: nowrap !important; font-size: 0.46rem !important; letter-spacing: 1.2px !important; }
  .me-page .me-hero-badge { font-size: 8px !important; padding: 5px 10px !important; gap: 5px !important; white-space: nowrap !important; }
  .me-page .me-hero-badge img { width: 11px !important; height: 11px !important; }
}
@media screen and (max-width: 430px) {
  .me-page .me-hero-title .line1 { font-size: 11.0vw !important; }
  .me-page .me-hero-title .line2 { font-size: 7vw !important; white-space: nowrap !important; }
  .me-page .me-hero-tagline { flex-wrap: nowrap !important; font-size: 0.42rem !important; letter-spacing: 1px !important; }
  .me-page .me-hero-badge { font-size: 7.5px !important; padding: 5px 8px !important; gap: 4px !important; white-space: nowrap !important; }
  .me-page .me-hero-badge img { width: 10px !important; height: 10px !important; }
}
@media screen and (max-width: 400px) {
  .me-page .me-hero-title .line1 { font-size: 11.5vw !important; }
  .me-page .me-hero-title .line2 { font-size: 7.4vw !important; white-space: nowrap !important; }
  .me-page .me-hero-tagline { flex-wrap: nowrap !important; font-size: 0.38rem !important; letter-spacing: 0.8px !important; }
  .me-page .me-hero-badge { font-size: 7px !important; padding: 5px 8px !important; gap: 3px !important; white-space: nowrap !important; }
  .me-page .me-hero-badge img { width: 9px !important; height: 9px !important; }
}
`;

// ─── IMAGE PATHS — swap these when you have the transparent PNGs ───────────
const HERO_IMG_TRICOLOR_TOP = "/Event/hero-tricolor-top.avif";
const HERO_IMG_WAVE         = "/Event/hero-tricolor-wav.png";
const HERO_IMG_SKYLINE      = "/Event/hero.avif";
const AWARDS_IMG            = "/Event/award_trophy.avif"; // ← put your awards photo path here, e.g. "/Event/awards-trophy.png"
const AWARDS_URL             = "/awards"; // ← internal route for the Awards page; update if your route path differs
// ─────────────────────────────────────────────────────────────────────────────

// ─── VENUE LOCATION (Google Maps) ──────────────────────────────────────────
// const VENUE_MAPS_URL = "https://maps.app.goo.gl/ati9FTAeqNHq9QDj8";
// ─────────────────────────────────────────────────────────────────────────────

const guestOfHonour = [
];

const honoraryPanel = [
];

const keynoteSpeakers = [];

const investorPanel = [
];

const legacyPanel = [];

const startupPanel = [
  
];

// ── ECOSYSTEM PARTNERS — add more entries here as they're confirmed.
// `img` is left null as a placeholder; swap in the real logo path once uploaded.
const ecosystemPartners = [
];

// ── MEDIA PARTNERS — add more entries here as they're confirmed.
// `img` is left null as a placeholder; swap in the real logo path once uploaded.
const mediaPartners = [];

const stats = [
  { num: "50,000+", label: "Entrepreneurs & Business Professionals Reached",  color: "#f37c23", icon: <svg viewBox="0 0 40 40" fill="none"><circle cx="14" cy="13" r="5" stroke="#f37c23" strokeWidth="2.5"/><path d="M4 32C4 26 8.5 22 14 22C19.5 22 24 26 24 32" stroke="#f37c23" strokeWidth="2.5" strokeLinecap="round"/><circle cx="28" cy="14" r="4" stroke="#f37c23" strokeWidth="2.5"/><path d="M24 28C26 27 28 27 30 27.5C33 28.5 35 31 35 34" stroke="#f37c23" strokeWidth="2.5" strokeLinecap="round"/></svg> },
  { num: "1,000+",  label: "Business Leaders & Founders Engaged",              color: "#002a9b", icon: <svg viewBox="0 0 40 40" fill="none"><circle cx="20" cy="13" r="6" stroke="#002a9b" strokeWidth="2.5"/><path d="M6 35C6 28 12 24 20 24C28 24 34 28 34 35" stroke="#002a9b" strokeWidth="2.5" strokeLinecap="round"/></svg> },
  { num: "100+",    label: "Industry Experts",                      color: "#00a000", icon: <svg viewBox="0 0 40 40" fill="none"><path d="M20 6L8 12V20C8 28 14 33 20 35C26 33 32 28 32 20V12L20 6Z" stroke="#00a000" strokeWidth="2.5" strokeLinejoin="round"/><path d="M14 20L18 24L26 16" stroke="#00a000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg> },
  { num: "50+",     label: "Government & Institutional Representatives",        color: "#7c3ab2", icon: <svg viewBox="0 0 40 40" fill="none"><rect x="6" y="14" width="28" height="20" rx="2" stroke="#7c3ab2" strokeWidth="2.5"/><path d="M12 14V10C12 7.8 15.6 6 20 6C24.4 6 28 7.8 28 10V14" stroke="#7c3ab2" strokeWidth="2.5"/><path d="M10 22H30" stroke="#7c3ab2" strokeWidth="2.5"/></svg> },
  { num: "200+",    label: "Investors & Strategic Partners",                    color: "#f37c23", icon: <svg viewBox="0 0 40 40" fill="none"><path d="M10 26L16 18L22 22L28 14" stroke="#f37c23" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M22 14H28V20" stroke="#f37c23" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg> },
  { num: "500+",    label: "High-Value B2B Networking Opportunities",           color: "#002a9b", icon: <svg viewBox="0 0 40 40" fill="none"><circle cx="12" cy="20" r="4" stroke="#002a9b" strokeWidth="2.5"/><circle cx="28" cy="12" r="4" stroke="#002a9b" strokeWidth="2.5"/><circle cx="28" cy="28" r="4" stroke="#002a9b" strokeWidth="2.5"/><path d="M16 20H24M16 18L24 14M16 22L24 26" stroke="#002a9b" strokeWidth="2" strokeLinecap="round"/></svg> },
  { num: "30+",     label: "Media & Digital Publication",                       color: "#00a000", icon: <svg viewBox="0 0 40 40" fill="none"><rect x="6" y="10" width="28" height="20" rx="3" stroke="#00a000" strokeWidth="2.5"/><circle cx="20" cy="20" r="5" stroke="#00a000" strokeWidth="2.5"/><circle cx="20" cy="20" r="1.5" fill="#00a000"/></svg> },
];

const connects = [
  { label: "VISIONARY FOUNDERS",  color: "#f37c23", bg: "rgba(243,124,35,0.1)",  icon: <svg viewBox="0 0 24 24" fill="none"><path d="M12 3L4 7V13C4 17.5 7.5 21 12 22C16.5 21 20 17.5 20 13V7L12 3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/><path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg> },
  { label: "CORPORATE HEADS",     color: "#002a9b", bg: "rgba(0,42,155,0.1)",    icon: <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="8" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M8 8V6C8 4.9 9.8 4 12 4C14.2 4 16 4.9 16 6V8" stroke="currentColor" strokeWidth="2"/><path d="M3 13H21" stroke="currentColor" strokeWidth="2"/></svg> },
  { label: "CHAMBER HEADS",       color: "#00a000", bg: "rgba(0,160,0,0.1)",     icon: <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/><path d="M3 12H21M12 3C14.5 5.5 14.5 18.5 12 21C9.5 18.5 9.5 5.5 12 3Z" stroke="currentColor" strokeWidth="2"/></svg> },
  { label: "CABINET MINISTERS",   color: "#7c3ab2", bg: "rgba(124,58,178,0.1)", icon: <svg viewBox="0 0 24 24" fill="none"><path d="M4 10H20M4 10V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V10M4 10L12 4L20 10" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/></svg> },
  { label: "ECONOMIC ADVISORS",   color: "#0091ff", bg: "rgba(0,145,255,0.1)",   icon: <svg viewBox="0 0 24 24" fill="none"><path d="M6 16L10 12L13 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 9H18V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><rect x="2" y="3" width="20" height="18" rx="2" stroke="currentColor" strokeWidth="2"/></svg> },
  { label: "MEDIA PARTNERS",      color: "#e00060", bg: "rgba(224,0,96,0.1)",    icon: <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="6" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="13" r="3" stroke="currentColor" strokeWidth="2"/><path d="M3 10H21" stroke="currentColor" strokeWidth="2"/></svg> },
];

const linkGroups = [
  {
    title: "Quick Links",
    links: [
      { label: "About", href: "#about" },
      { label: "Networking", href: "#networking" },
      { label: "Speakers", href: "#speakers" },
      { label: "Sponsors", href: "#sponsors" },
    ],
  },
  {
    title: "Sponsorships",
    links: [
      { label: "Event Brochure", href: "/Event/Freedom Conclave 2026_Event Brochure.pdf" },
      { label: "Sponsorship Opportunities", href: "/Event/Freedom Conclave 2026_Sponsorship Slabs.pdf" },
      { label: "Partner with Us", href: "mailto:connect@myibh.in" },
    ],
  },
];

const socials = [
  { icon: "fa-brands fa-linkedin-in", url: "https://www.linkedin.com/company/india-business-helpline/", hoverBg: "#0A66C2" },
  { icon: "fa-brands fa-x-twitter", url: "https://x.com/ibh_info", hoverBg: "#1a1a1a" },
  { icon: "fa-brands fa-instagram", url: "https://www.instagram.com/indiabusinesshelpline/", hoverBg: "#E1306C" },
  { icon: "fa-brands fa-youtube", url: "https://www.youtube.com/@indiabusinesshelpline", hoverBg: "#FF0000" },
  { icon: "fa-brands fa-whatsapp", url: "https://wa.me/918274964884", hoverBg: "#25D366" },
  { icon: "fa-brands fa-facebook-f", url: "https://www.facebook.com/profile.php?id=61566777813226", hoverBg: "#1877F2" },
];

// ── FAQ CONTENT ─────────────────────────────────────────────────────────────
const FAQ_ITEMS = [
  {
    q: "What is Freedom Conclave 2026?",
    a: "It's a business and entrepreneurship conclave organized by India Business Helpline (IBH), themed \u201CThe Rise of New Bengal,\u201D bringing together entrepreneurs, investors, policymakers, and industry leaders in Kolkata.",
  },
  {
    q: "When and where is the event happening?",
    a: "19th December, 2026. The time and venue will be announced soon.",
  },
  
  {
    q: "Who is organizing the event?",
    a: "India Business Helpline (IBH), described as \u201CThe Complete Business Support Ecosystem.\u201D",
  },
  {
    q: "Who is the Guest of Honour?",
    a: "Will be revealed before the event.",
  },
  {
    q: "Who should attend this conclave?",
    a: "Entrepreneurs, startup founders, MSMEs, manufacturers, investors, policymakers, professionals, women entrepreneurs, students, and aspiring entrepreneurs.",
  },
  {
    q: "How many people are expected to attend?",
    a: "500+ attendees overall, including 150+ entrepreneurs, 150+ founders, 100+ professionals, 100+ startups/MSMEs, 30+ investors & strategic partners, 15+ business leaders, and 5+ government/institutional representatives.",
  },
  {
    q: "What can attendees expect to gain from the event?",
    a: "Practical insights, high-value networking, strategic connections, investor access, mentorship opportunities, and long-term partnership opportunities.",
  },
  {
    q: "What is India Business Helpline (IBH)?",
    a: "A rapidly growing business support ecosystem that helps entrepreneurs, startups, and MSMEs through strategic consulting, funding facilitation, compliance support, technology enablement, branding, and networking.",
  },
  {
    q: "What is IBH's long-term vision?",
    a: "A 10-year vision for West Bengal including 10,000 successful businesses built, \u20B9100,000 Cr in business opportunities facilitated, reach across 2,500+ colleges, and 10,00,000 jobs created via entrepreneurship.",
  },
  {
    q: "Does the event include investor/funding opportunities?",
    a: "Yes \u2014 IBH connects entrepreneurs with angel investors, venture capitalists, banks, NBFCs, and government funding schemes through investor matchmaking and pitch preparation support. The event also features the Startup Launch Pad, where selected startups can showcase their ventures, gain visibility, receive expert feedback, and explore potential funding and strategic partnership opportunities.",
  },
  {
    q: "Are there networking or B2B opportunities at the conclave?",
    a: "Yes, the brochure highlights 500+ high-value B2B networking opportunities and 200+ investors & strategic partners as part of IBH's broader network.",
  },
  {
    q: "Will there be panel discussions or knowledge sessions?",
    a: "Yes, the event's broader network engagement includes 15+ knowledge sessions and panel discussions along with 100+ industry experts and speakers.",
  },
  {
    q: "How can someone contact organizers or register?",
    a: "Via phone: +91 82749 64884 / +91 81003 01388, email: connect@myibh.in, or by visiting www.myibh.in (also accessible via the QR code on the Event Brochure.",
  },
  {
    q: "Why is the event themed around \u201C79 Reasons of Progress\u201D / Independence?",
    a: "The conclave coincides with celebrating 79 years of India's independence, framing Bengal's entrepreneurial resurgence as part of the nation's ongoing story of progress.",
  },
  {
    q: "What is the dress code for the event?",
    a: "Formal or semi-formal attire is recommended for all attendees.",
  },
];

function FaqItem({ item, isOpen, onToggle }) {
  return (
    <div className={`me-faq-item${isOpen ? " open" : ""}`}>
      <button className="me-faq-question" onClick={onToggle} aria-expanded={isOpen}>
        <span className="me-faq-q-text"><span>Q.</span> {item.q}</span>
        <svg
          className={`me-faq-chevron${isOpen ? " open" : ""}`}
          viewBox="0 0 24 24" fill="none" width="18" height="18"
        >
          <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      <div className={`me-faq-answer${isOpen ? " open" : ""}`}>
        <div className="me-faq-answer-inner">{item.a}</div>
      </div>
    </div>
  );
}

const SocialIcon = ({ icon, url, hoverBg }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        backgroundColor: hovered ? hoverBg : "rgba(255,255,255,0.08)",
        borderColor: hovered ? hoverBg : "rgba(255,255,255,0.10)",
        borderWidth: "1px",
        borderStyle: "solid",
        transition: "background-color 0.2s, border-color 0.2s",
      }}
      className="h-10 w-10 rounded-full flex items-center justify-center"
    >
      <i className={`${icon} text-sm text-white`}></i>
    </a>
  );
};

// ─── FLOATING "FIND YOUR WAY TO THE VENUE" BUTTON ──────────────────────────
// const VenueFloatingButton = () => {
//   return (
//     <a
//       href={VENUE_MAPS_URL}
//       target="_blank"
//       rel="noopener noreferrer"
//       className="me-venue-btn"
//     >
//       <svg viewBox="0 0 24 24" fill="none">
//         <path d="M12 22C12 22 20 15 20 10A8 8 0 0 0 4 10C4 15 12 22 12 22Z" stroke="#fff" strokeWidth="2"/>
//         <circle cx="12" cy="10" r="3" stroke="#fff" strokeWidth="2"/>
//       </svg>
//       <span className="me-venue-btn-label">Find your way to the venue</span>
//     </a>
//   );
// };
// ─────────────────────────────────────────────────────────────────────────────

const StatCounter = ({ value, color }) => {
  const ref = useRef(null);
  const [display, setDisplay] = useState("0");
  const startedRef = useRef(false);

  useEffect(() => {
    const match = String(value).match(/^([\d,]+)(.*)$/);
    if (!match) { setDisplay(value); return; }
    const target = parseInt(match[1].replace(/,/g, ""), 10);
    const suffix = match[2] || "";
    const el = ref.current;
    if (!el) return;

    const runAnimation = () => {
      const duration = 1600;
      const startTime = performance.now();
      const step = (now) => {
        const progress = Math.min((now - startTime) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = Math.floor(eased * target);
        setDisplay(current.toLocaleString("en-US") + suffix);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          setDisplay(target.toLocaleString("en-US") + suffix);
        }
      };
      requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !startedRef.current) {
            startedRef.current = true;
            runAnimation();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [value]);

  return (
    <div className="me-stat-num" style={{ color }} ref={ref}>
      {display}
    </div>
  );
};

function useSpeakerReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { setVisible(entry.isIntersecting); },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return [ref, visible];
}

function SpeakerCard({ s, delay = 0 }) {
  const [ref, visible] = useSpeakerReveal();
  const initials = s.name.split(" ").map(w => w[0]).slice(0, 2).join("");
  return (
    <div ref={ref}>
      <div
        className={`me-speaker-glass-card me-speaker-reveal${visible ? " visible" : ""}`}
        style={{ transitionDelay: `${delay}ms` }}
      >
        <div className="me-speaker-glass-photo">
          {s.img ? <img src={s.img} alt={s.name} /> : <span className="placeholder-initials">{initials}</span>}
        </div>
        <h4>{s.name}</h4>
        <p>
  {s.role.split("|").map((line, i, arr) => (
    <React.Fragment key={i}>
      {line.trim()}
      {i < arr.length - 1 && <br />}
    </React.Fragment>
  ))}
</p>
      </div>
    </div>
  );
}

function MoreToComeCard({ delay = 0 }) {
  const [ref, visible] = useSpeakerReveal();
  return (
    <div ref={ref}>
      <div
        className={`me-speaker-glass-card me-speaker-reveal${visible ? " visible" : ""}`}
        style={{ transitionDelay: `${delay}ms` }}
      >
        <div
          className="me-speaker-glass-photo"
          style={{ border: "2px dashed rgba(255,255,255,0.25)", background: "rgba(255,255,255,0.04)" }}
        >
          <svg viewBox="0 0 24 24" fill="none" width="32" height="32">
            <circle cx="9" cy="8" r="3" stroke="rgba(255,255,255,0.5)" strokeWidth="1.8"/>
            <path d="M3 20C3 16.5 5.5 14 9 14C12.5 14 15 16.5 15 20" stroke="rgba(255,255,255,0.5)" strokeWidth="1.8" strokeLinecap="round"/>
            <path d="M14 15C16.5 15.3 18.5 17.3 18.5 20" stroke="rgba(255,255,255,0.5)" strokeWidth="1.8" strokeLinecap="round"/>
            <circle cx="16" cy="8" r="2.3" stroke="rgba(255,255,255,0.5)" strokeWidth="1.8"/>
            <path d="M19 5L19.6 6.4L21 7L19.6 7.6L19 9L18.4 7.6L17 7L18.4 6.4L19 5Z" fill="#f37c23"/>
          </svg>
        </div>
        <h4>More to come</h4>
        <p>Stay tuned!</p>
      </div>
    </div>
  );
}

const MegaEvent = () => {
  const navigate = useNavigate();
const location = useLocation();

const REGISTER_PATH = "/freedom-conclave/register";

// All URLs that should count as "the register modal is open" —
// the choice screen path, plus the direct per-flow paths (event /
// pitching / audience) that RegisterModal's PATH_TO_FLOW maps to a step.
const REGISTER_PATHS = [
  REGISTER_PATH,
  "/freedom-conclave/register-event",
  "/freedom-conclave/register-event/details",
  "/freedom-conclave/register-pitching",
  "/freedom-conclave/register-pitching/details",
  "/freedom-conclave/register-pitching-audience",
  "/freedom-conclave/register-pitching-audience/details",
];

// Modal is "open" whenever the URL matches any of the register paths
const modalOpen = REGISTER_PATHS.includes(location.pathname);

const openModal = (e) => {
  e.preventDefault();
  navigate(REGISTER_PATH); // pushes new URL, modal opens because pathname now matches
};

const closeModal = () => {
  navigate(-1); // go back to previous URL (e.g. /freedom-conclave), modal closes
};
  const [openFaqIndex, setOpenFaqIndex] = useState(-1);

  return (
    <div className="me-page">
      <Helmet>
      <title>Freedom Conclave™ 2026 | IBH — India Business Helpline</title>
      <meta name="description" content="Freedom Conclave™ 2026 — India Business Helpline's flagship business and entrepreneurship conclave, themed 'The Rise of New Bengal'." />
    </Helmet>
      <style>{meStyles}</style>

      <RegisterModal
  isOpen={modalOpen}
  onClose={closeModal}
  navigate={navigate}
  pathname={location.pathname}
/>
      {/* {!modalOpen && <VenueFloatingButton />} */}

      <EventNavbar />

      {/* ===== HERO CARD ===== */}
      <div className="me-hero-wrapper">
        <div className="me-hero-card">

          <img className="me-hero-img-tricolor-top" src={HERO_IMG_TRICOLOR_TOP} alt="" aria-hidden="true" />
          <img className="me-hero-img-skyline" src={HERO_IMG_SKYLINE} alt="" aria-hidden="true" />

          <div className="me-hero-content">

            <div className="me-hero-presents">
              <span style={{ color: "#f37c23" }}>INDIA </span>
              <span style={{ color: "#002a9b" }}>BUSINESS </span>
              <span style={{ color: "#00a000" }}>HELPLINE</span>
              <em>Presents</em>
            </div>

           <div className="me-hero-badge" style={{ whiteSpace: "nowrap" }}>
  <img src="/Event/badge-icon.avif" alt="badge icon" style={{ width: "20px", height: "20px", objectFit: "contain", flexShrink: 0 }} />
  EAST INDIA'S BIGGEST BUSINESS CONCLAVE
</div>

            <h1 className="me-hero-title">
              <span className="line1">
                FREEDOM<sup style={{
                  fontSize: "0.15em",
                  fontWeight: 350,
                  fontFamily: "'Poppins', sans-serif",
                  letterSpacing: "0.02em",
                  color: "#0d1433",
                  verticalAlign: "super",
                  position: "relative",
                  top: "-1.65em",
                  marginLeft: "1px",
                }}>TM</sup>
              </span>
              <span className="line2">
                CONCLAVE{" "}
                <span className="yr" style={{ fontFamily: "'Times New Roman', Times, serif",lineHeight: "1.5" }}>2026</span>
              </span>

            </h1>

            <div className="me-hero-tagline">
              INSPIRE
              <span className="dot" />
              NETWORK
              <span className="dot" />
              COLLABORATE
              <span className="dot" />
              INFLUENCE
            </div>

            <div className="me-hero-subtitle">Building a Self-Reliant India</div>
            <div className="me-hero-sub2">Through Innovation, Enterprise</div>
            <div className="me-hero-sub3">&amp; Inclusive Growth</div>

            <div className="me-hero-feature">
              <div className="me-hero-feature-icon" style={{ position: "relative", zIndex: 10 }}>
                <i className="fa-solid fa-handshake" style={{ color: "#f37c23", fontSize: "22px", position: "relative", zIndex: 10 }}></i>
              </div>
              <div className="me-hero-feature-text">
                Unlock High-Value<br />Business Connections
              </div>
            </div>

            {/* ── CHANGE 1: Hero Register Now → opens modal ── */}
            <button onClick={openModal} className="me-hero-register-btn" aria-label="Open Freedom Conclave 2026 registration form">
              Register Now
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
                <path d="M13 6L19 12L13 18" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          <div style={{
            position: "absolute", inset: 0,
            background: `
              radial-gradient(ellipse 100% 70% at -5% -5%, rgba(255,140,30,0.60) 0%, rgba(255,160,60,0.25) 32%, transparent 55%),
              radial-gradient(ellipse 100% 70% at 105% 85%, rgba(10,120,10,0.65) 0%, rgba(19,136,8,0.30) 32%, transparent 55%)
            `,
            pointerEvents: "none", zIndex: 2,
          }} />

          <div className="me-hero-bottom">
            <img className="me-hero-wave-svg" src={HERO_IMG_WAVE} alt="" aria-hidden="true" />
            <div className="me-hero-stats-bar">
              <div className="me-hero-stat-item">
                <div className="me-hero-stat-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="4" width="18" height="17" rx="2" stroke="currentColor" strokeWidth="2"/>
                    <path d="M3 9H21M8 2V6M16 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <div>
                  <div className="me-hero-stat-label">DATE</div>
                  <div className="me-hero-stat-val">19 December 2026</div>
                </div>
              </div>
              <div className="me-hero-stat-item">
                <div className="me-hero-stat-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
                    <path d="M12 7V12L15 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <div>
                  <div className="me-hero-stat-label">TIME</div>
                  <div className="me-hero-stat-val">TBD</div>
                </div>
              </div>
              <div className="me-hero-stat-item">
                <div className="me-hero-stat-icon">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C12 22 20 15 20 10A8 8 0 0 0 4 10C4 15 12 22 12 22Z" stroke="currentColor" strokeWidth="2"/>
                    <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <div>
                  <div className="me-hero-stat-label">VENUE</div>
                  <div className="me-hero-stat-val">TBD (Kolkata)</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

       {/* ===== AWARDS CARD ===== */}
      {/* <div className="me-awards-wrapper" id="awards">
        <div className="me-awards-card">
          <div className="me-awards-left">
            <div className="me-awards-trophy" role="img" aria-label="Award image placeholder">
              {AWARDS_IMG ? (
                <img
                  src={AWARDS_IMG}
                  alt="Freedom Awards"
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                />
              ) : (
                <svg viewBox="0 0 24 24" fill="none" width="34" height="34">
                  <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8"/>
                  <circle cx="8.5" cy="9.5" r="1.7" stroke="currentColor" strokeWidth="1.8"/>
                  <path d="M3 16L8 12L11 14.5L16 10L21 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
            <div>
              <div className="me-awards-label">Recognizing Excellence</div>
              <h3 className="me-awards-title">Freedom Awards <span className="yr">2026</span></h3>
              <p className="me-awards-desc">Honoring India's most inspiring entrepreneurs, startups, and businesses.</p>
            </div>
          </div>

          <div className="me-awards-features">
            <div className="me-awards-feature">
              <svg viewBox="0 0 24 24" fill="none"><rect x="4" y="4" width="16" height="16" rx="3" stroke="currentColor" strokeWidth="2"/><path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              Multiple Categories
            </div>
            <div className="me-awards-feature">
              <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/><path d="M5 21C5 17 8 14.5 12 14.5C16 14.5 19 17 19 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
              Expert Jury
            </div>
            <div className="me-awards-feature">
              <svg viewBox="0 0 24 24" fill="none"><path d="M12 2L14.5 8.5L21 9L16 13.5L17.5 20L12 16.5L6.5 20L8 13.5L3 9L9.5 8.5L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/></svg>
              National Recognition
            </div>
          </div>

          <div className="me-awards-cta">
            <a
              href={AWARDS_URL || "#awards"}
              target="_blank"
              rel="noopener noreferrer"
              className="me-awards-btn"
            >
              Open for Nominations
              <svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M5 12H19" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/><path d="M13 6L19 12L13 18" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
          </div>
        </div>
      </div>  */}

      {/* ===== VISION ===== */}
      <section className="me-vision-section" id="about">
        <div className="me-container">
          <div className="me-vision-grid">
            <div>
              <div style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "2.5px", color: "#f37c23", textTransform: "uppercase", display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px", fontFamily: "'Poppins', sans-serif" }}>
                OUR VISION
                <span style={{ height: "1.5px", width: "60px", background: "#f37c23", display: "inline-block" }} />
              </div>
              <h2 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 800, fontSize: "clamp(1.4rem, 2.4vw, 2.1rem)", color: "#0d1433", lineHeight: 1.15, margin: "0 0 26px", textTransform: "uppercase" }}>
                The Vision Behind<br />Freedom Conclave <span style={{ color: "#f37c23" }}>2026</span>
              </h2>
              <span style={{ fontFamily: "'Times New Roman', Times, serif", fontSize: "48px", fontWeight: 900, color: "#f37c23", lineHeight: 0.6, display: "block", marginBottom: "-5px" }}>&ldquo;</span>
              <p style={{ fontSize: "15px", lineHeight: 1.85, color: "#2d3352", margin: "10px 0 0",textAlign: "justify" }}>
                No entrepreneur should fail simply because they lack access to knowledge, networks, capital, or guidance. IBH exists to change that – for every founder, in every city.
              </p>
              <span style={{ fontFamily: "'Times New Roman', Times, serif", fontSize: "48px", fontWeight: 900, color: "#f37c23", lineHeight: 0.6, display: "block", textAlign: "right", marginTop: "18px" }}>&rdquo;</span>
            </div>
            <div style={{ background: "#0d1433", borderRadius: "24px", padding: "44px 40px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "22px" }}>
                <div style={{ width: "50px", height: "50px", borderRadius: "50%", border: "2.5px solid #f37c23", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <ellipse cx="12" cy="12" rx="9" ry="6" stroke="#f37c23" strokeWidth="2"/>
                    <circle cx="12" cy="12" r="2.5" fill="#f37c23"/>
                    <path d="M3 12C5 9 8.5 7 12 7C15.5 7 19 9 21 12" stroke="#f37c23" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: "14px", fontWeight: 700, letterSpacing: "2px", color: "#fff", textTransform: "uppercase" }}>OUR VISION</span>
              </div>
              <p style={{ fontSize: "15.5px", lineHeight: 1.9, color: "#b8c6e0", margin: 0 }}>
                To become the bridge between entrepreneurs, opportunities, and government &amp; private support systems across India and empower lasting success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== STATS ===== */}
      <section className="me-stats-section" id="networking">
        <div className="me-container">
          <div className="me-stats-grid">
            {stats.map((s, i) => (
              <div className="me-stat-item" key={i}>
                <div className="me-stat-icon-wrap">{s.icon}</div>
                <StatCounter value={s.num} color={s.color} />
                <div className="me-stat-lbl">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CONNECT ===== */}
      <section className="me-connect-section">
        <div className="me-container">
          <div className="me-section-divider-title"><h2>WHO YOU'LL CONNECT WITH</h2></div>
          <div className="me-connect-grid">
            {connects.map((c, i) => (
              <div className="me-connect-card" key={i}>
                <div className="me-connect-icon" style={{ background: c.bg, color: c.color }}>{c.icon}</div>
                <h4>{c.label}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== SPEAKERS ===== */}
      <section className="me-speakers-section" id="speakers">
  <div className="me-container">
    <div className="me-section-divider-title" style={{ marginBottom: "48px" }}>
      <h2 style={{ color: "#fff" }}>MEET <span style={{ color: "var(--orange)" }}>OUR SPEAKERS</span></h2>
    </div>

    {[
      { title: "Guest of Honour", data: guestOfHonour },
      { title: "Honorary Invitees",  data: honoraryPanel },
      { title: "Keynote Speakers", data: keynoteSpeakers},
     
      { title: "Legacy Panel",    data: legacyPanel },
      { title: "Startup Panel",   data: startupPanel },
       { title: "Investor Panel", data: investorPanel},
    ].map(({ title, data, showMore }, idx, arr) => {
      const totalCount = data.length + (showMore ? 1 : 0);
      const cols = Math.min(totalCount || 1, 4);
      return (
        <React.Fragment key={title}>
          <div className="me-speakers-subsection-title">{title}</div>
          {data.length || showMore ? (
            <div className={`me-speaker-subgrid cols-${cols}`}>
              {data.map((s, i) => (
                <SpeakerCard key={title + i} s={s} delay={(i % 4) * 100} />
              ))}
              {showMore && <MoreToComeCard delay={(data.length % 4) * 100} />}
            </div>
          ) : (
            <div className="me-speaker-coming-soon">
              <p>Coming Soon</p>
            </div>
          )}
          {idx < arr.length - 1 && (
            <div style={{ height: "1px", background: "rgba(255,255,255,0.08)", margin: "0 0 48px" }} />
          )}
        </React.Fragment>
      );
    })}

  </div>
</section>

      

      {/* ===== SPONSORS ===== */}
      <section className="me-sponsors-section" id="sponsors">
        <div className="me-container">
          <div className="me-section-divider-title"><h2>OUR SPONSORS &amp; PARTNERS</h2></div>

          <div className="me-sponsors-tier">
            <div className="me-sponsors-tier-label">PRESENTING SPONSOR</div>
            <div style={{ border: "1.5px dashed var(--line)", borderRadius: "14px", padding: "40px 20px", textAlign: "center" }}>
              <div style={{ width: "44px", height: "44px", margin: "0 auto 12px", borderRadius: "10px", background: "var(--line)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg viewBox="0 0 24 24" fill="none" width="22" height="22"><path d="M20 12V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V12" stroke="var(--muted)" strokeWidth="1.5"/><rect x="2" y="7" width="20" height="5" rx="1" stroke="var(--muted)" strokeWidth="1.5"/><path d="M12 22V7M12 7C12 7 9 2 6.5 4C4 6 7 7 12 7ZM12 7C12 7 15 2 17.5 4C20 6 17 7 12 7Z" stroke="var(--muted)" strokeWidth="1.5"/></svg>
              </div>
              <h4 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.95rem", fontWeight: 700, color: "var(--ink)", marginBottom: "6px" }}>COMING SOON!</h4>
              <p style={{ fontSize: "0.78rem", color: "var(--muted)", margin: 0 }}>Our amazing sponsors will be revealed soon.</p>
            </div>
          </div>

          <div className="me-sponsors-bottom" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "40px" }}>
            <div className="me-sponsors-tier">
              <div className="me-sponsors-tier-label">POWERED-BY SPONSORS</div>
              <div style={{ border: "1.5px dashed var(--line)", borderRadius: "14px", padding: "32px 16px", textAlign: "center" }}>
                <div style={{ width: "38px", height: "38px", margin: "0 auto 10px", borderRadius: "10px", background: "var(--line)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M20 12V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V12" stroke="var(--muted)" strokeWidth="1.5"/><rect x="2" y="7" width="20" height="5" rx="1" stroke="var(--muted)" strokeWidth="1.5"/><path d="M12 22V7M12 7C12 7 9 2 6.5 4C4 6 7 7 12 7ZM12 7C12 7 15 2 17.5 4C20 6 17 7 12 7Z" stroke="var(--muted)" strokeWidth="1.5"/></svg>
                </div>
                <h4 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.85rem", fontWeight: 700, color: "var(--ink)", marginBottom: "5px" }}>COMING SOON!</h4>
                <p style={{ fontSize: "0.72rem", color: "var(--muted)", margin: 0 }}>Our valued sponsors will be announced soon.</p>
              </div>
            </div>
            <div className="me-sponsors-tier">
              <div className="me-sponsors-tier-label">ECOSYSTEM PARTNERS</div>
              {ecosystemPartners.length ? (
                <div className="me-ecosystem-grid">
                  {ecosystemPartners.map((p, i) => (
                    <div className="me-partner-card" key={i}>
                      <div className="me-partner-photo">
                        {p.img ? (
                          <img src={p.img} alt={p.name} />
                        ) : (
                          <svg viewBox="0 0 24 24" fill="none"><path d="M20 12V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V12" stroke="var(--muted)" strokeWidth="1.5"/><rect x="2" y="7" width="20" height="5" rx="1" stroke="var(--muted)" strokeWidth="1.5"/><path d="M12 22V7M12 7C12 7 9 2 6.5 4C4 6 7 7 12 7ZM12 7C12 7 15 2 17.5 4C20 6 17 7 12 7Z" stroke="var(--muted)" strokeWidth="1.5"/></svg>
                        )}
                      </div>
                      <div className="me-partner-name">{p.name}</div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ border: "1.5px dashed var(--line)", borderRadius: "14px", padding: "32px 16px", textAlign: "center" }}>
                  <div style={{ width: "38px", height: "38px", margin: "0 auto 10px", borderRadius: "10px", background: "var(--line)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M20 12V20C20 21.1 19.1 22 18 22H6C4.9 22 4 21.1 4 20V12" stroke="var(--muted)" strokeWidth="1.5"/><rect x="2" y="7" width="20" height="5" rx="1" stroke="var(--muted)" strokeWidth="1.5"/><path d="M12 22V7M12 7C12 7 9 2 6.5 4C4 6 7 7 12 7ZM12 7C12 7 15 2 17.5 4C20 6 17 7 12 7Z" stroke="var(--muted)" strokeWidth="1.5"/></svg>
                  </div>
                  <h4 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "0.85rem", fontWeight: 700, color: "var(--ink)", marginBottom: "5px" }}>COMING SOON!</h4>
                  <p style={{ fontSize: "0.72rem", color: "var(--muted)", margin: 0 }}>Our ecosystem partners will be announced soon.</p>
                </div>
              )}
            </div>
          </div>

          {/* <div className="me-sponsors-tier" style={{ marginTop: "40px" }}>
            <div className="me-sponsors-tier-label">MEDIA & OUTDOOR PARTNERS</div>
            <div className="me-media-wrapper">
              <div className="me-media-grid">
                {mediaPartners.map((m, i) => (
                  <div className="me-media-card" key={i}>
                    <div className="me-media-logo">
                      {m.img ? (
                        <img src={m.img} alt={m.name} />
                      ) : (
                        <svg viewBox="0 0 24 24" fill="none" width="40" height="40"><rect x="3" y="6" width="18" height="14" rx="2" stroke="var(--muted)" strokeWidth="1.5"/><circle cx="12" cy="13" r="3" stroke="var(--muted)" strokeWidth="1.5"/><path d="M3 10H21" stroke="var(--muted)" strokeWidth="1.5"/></svg>
                      )}
                    </div>
                    <div className="me-media-name">{m.name}</div>
                    {m.role && <div className="me-media-role">{m.role}</div>}
                  </div>
                ))}
              </div>
            </div>
          </div> */}
        </div>
      </section>

      {/* ===== FOOTER CTA ===== */}
      <section className="me-footer-cta" id="register">
        <div className="me-container">
          <div className="me-footer-cta-card">
            <div className="me-footer-cta-bg" />
            <div className="me-footer-cta-inner">
              <div className="me-footer-cta-left">
                <h2>Let's build the future of<br />India, <span className="accent">together.</span></h2>
                <p>Be a part of meaningful conversations, valuable connections and endless opportunities.</p>
              </div>
              <div className="me-footer-cta-middle">
                <div className="me-footer-cta-detail">
                  <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="17" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M3 9H21M8 2V6M16 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                  19 December 2026
                </div>
                <div className="me-footer-cta-detail">
                  <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/><path d="M12 7V12L15 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                  TBD
                </div>
                <div className="me-footer-cta-detail">
                  <svg viewBox="0 0 24 24" fill="none"><path d="M12 22C12 22 20 15 20 10A8 8 0 0 0 4 10C4 15 12 22 12 22Z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/></svg>
                  TBD (Kolkata)
                </div>
              </div>
              <div className="me-footer-cta-right-col" style={{ background: "rgba(255,255,255,0.08)", backdropFilter: "blur(16px)", WebkitBackdropFilter: "blur(16px)", border: "1px solid rgba(255,255,255,0.18)", borderRadius: "18px", padding: "32px 28px", textAlign: "center", boxShadow: "0 8px 32px rgba(0,0,0,0.25)" }}>
                <h3 style={{ fontFamily: "'Poppins', sans-serif", fontSize: "1.1rem", fontWeight: 800, color: "#ffffff", textTransform: "uppercase", letterSpacing: "0.5px", lineHeight: 1.4, marginBottom: "24px" }}>
                  LIMITED SEATS.<br />REGISTER EARLY!
                </h3>
                {/* ── CHANGE 2: Footer Register Now → opens modal ── */}
                <button
                  onClick={openModal}
                  style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", background: "#f37c23", color: "#fff", fontFamily: "'Poppins', sans-serif", fontWeight: 700, fontSize: "1rem", padding: "16px 28px", borderRadius: "50px", border: "none", cursor: "pointer", transition: "background 0.2s", width: "100%" }}
                  onMouseEnter={e => e.currentTarget.style.background = "#c55e10"}
                  onMouseLeave={e => e.currentTarget.style.background = "#f37c23"}
                  aria-label="Register now — limited seats available"
                >
                  Register Now
                  <svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M5 12H19" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/><path d="M13 6L19 12L13 18" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FAQ ===== */}
      <section className="me-faq-section" id="faq">
        <div className="me-container">
          <div className="me-section-divider-title"><h2>FREQUENTLY ASKED QUESTIONS</h2></div>

          <div className="me-faq-list">
            {FAQ_ITEMS.map((item, i) => (
              <FaqItem
                key={item.q}
                item={item}
                isOpen={openFaqIndex === i}
                onToggle={() => setOpenFaqIndex(openFaqIndex === i ? -1 : i)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer id="contact" className="bg-ibh-navy text-white relative overflow-hidden" data-testid="footer">
        <div className="absolute inset-0 grain mix-blend-overlay"></div>
        <div className="absolute -top-32 right-0 h-72 w-72 rounded-full bg-ibh-green/15 blur-3xl"></div>
        <div className="section relative pt-20 pb-10">
          <div className="grid lg:grid-cols-12 gap-x-20 gap-y-12">
            <div className="lg:col-span-4">
              <Wordmark light />
              <p className="mt-5 text-white/65 text-sm max-w-sm leading-relaxed">
                India Business Helpline (IBH) is the all-in-one ecosystem helping startups, MSMEs and entrepreneurs navigate every stage of business — with expert guidance and a powerful community.
              </p>
              <div className="mt-6 flex items-center gap-3">
                {socials.map((s, i) => (<SocialIcon key={i} {...s} />))}
              </div>
            </div>

            {linkGroups.map((g) => (
              <div key={g.title} className="lg:col-span-2">
                <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider">{g.title}</h4>
                <ul className="mt-5 space-y-3">
                  {g.links.map((l) => (
                    <li key={l.label}>
                      <a href={l.href} className="text-sm text-white/65 hover:text-white transition-colors" target={l.href.startsWith("http") ? "_blank" : undefined} rel={l.href.startsWith("http") ? "noopener noreferrer" : undefined}>
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="lg:col-span-2">
              <h4 className="font-display font-bold text-white text-sm uppercase tracking-wider">Contact US</h4>
              <ul className="mt-5 space-y-3 text-sm text-white/70">
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-envelope mt-1 text-ibh-green"></i>
                  <a href="mailto:indianbusinesshelpline@gmail.com" className="hover:text-white transition-colors">Click to E-Mail</a>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-phone mt-1 text-ibh-green"></i>
                  <a href="tel:+918100301388" className="hover:text-white transition-colors whitespace-nowrap">+91 81003 01388</a>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-phone mt-1 text-ibh-green"></i>
                  <a href="tel:+918274964884" className="hover:text-white transition-colors whitespace-nowrap">+91 82749 64884</a>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-location-dot mt-1 text-ibh-green"></i>
                  <a href="https://maps.app.goo.gl/rnJSMm8raQDGcMGi8" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Kolkata</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/50">
            <p>© {new Date().getFullYear()} India Business Helpline. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MegaEvent;